import { makeStyles } from '@material-ui/core'
import { Box } from '@plvs/respawn/features/layout'
import {
  OptionalWeeksCache,
  SeasonEnrollmentRangeData,
} from '@plvs/respawn/containers/enrollment/types'
import React, { useEffect } from 'react'
import { NxTypography } from '@playvs-inc/nexus-components'
import { OptionalWeekContent } from './OptionalWeeksContent'

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    verticalAlign: 'top',
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.BorderLight}`,
    borderRadius: '8px',
    padding: theme.spacing(3),
    width: '100%',
    background: theme.palette.ColorBackgroundBase,
  },
  title: {
    color: theme.palette.ColorTextBase,
  },
  subtitle: {
    color: theme.palette.ColorTextBase,
    padding: theme.spacing(1.5, 0, 0),
  },
}))

export interface OptionalWeeksCardProps {
  setOptionalSeasonWeeksCache(input: OptionalWeeksCache): void

  optionalSeasonWeeksCache: OptionalWeeksCache
  seasonSlotExclusionRangeData: SeasonEnrollmentRangeData
}

export const OptionalWeeksCard: React.FC<OptionalWeeksCardProps> = ({
  seasonSlotExclusionRangeData,
  optionalSeasonWeeksCache,
  setOptionalSeasonWeeksCache,
}) => {
  const classes = useStyles()
  const [show, setShow] = React.useState(
    seasonSlotExclusionRangeData.length > 0
  )

  useEffect(() => {
    setShow(seasonSlotExclusionRangeData.length > 0)
  }, [seasonSlotExclusionRangeData.length])

  if (!show) {
    return null
  }

  return (
    <Box
      alignItems="flex-start"
      className={classes.container}
      display="flex"
      flexDirection="column"
    >
      <NxTypography className={classes.title} variant="h3">
        Break Week Selection
      </NxTypography>
      <NxTypography className={classes.subtitle} variant="body3">
        You can designate a regular season break week for each league to avoid
        unnecessary forfeitures and reschedules. The break week you select will
        only apply to the league you are selecting it for. All teams in the same
        league will share the same break week. Some leagues may not have a break
        week, and you will not be able to select a break week for that league.
      </NxTypography>

      {seasonSlotExclusionRangeData.map((data, idx) => {
        const {
          configuration,
          seasonId,
          resourceId,
          resourceType,
          leagueName,
        } = data
        const key = `${seasonId}-${idx}`
        return (
          <OptionalWeekContent
            key={key}
            configuration={configuration}
            optionalWeeksCache={optionalSeasonWeeksCache}
            range={seasonId}
            resourceId={resourceId}
            resourceType={resourceType}
            seasonId={seasonId}
            selectLabel={leagueName}
            setOptionalWeeksCache={setOptionalSeasonWeeksCache}
          />
        )
      })}
    </Box>
  )
}
